import { render } from "./CollectionFallbackImage.vue?vue&type=template&id=020bb4dd&scoped=true"
import script from "./CollectionFallbackImage.vue?vue&type=script&lang=js"
export * from "./CollectionFallbackImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020bb4dd"]])

export default __exports__